import useData from './useData'

export default useData
